import { format } from "date-fns";
import React from "react";
import "./MemberRating.css";
import type { FirebaseTimestamp } from "../../../common/types/FirebaseTimestamp";
import { fromTimestampToDate } from "../../../utils/timestamp.util";
import Stars from "./Stars";

type Props = {
    maxRating?: number;
    userRating: number;
    message?: string | undefined | null;
    timestamp?: FirebaseTimestamp | undefined | null;
    ratingBy?: string | undefined | null;
};
export default function MemberRating({
    maxRating,
    userRating,
    message,
    timestamp,
    ratingBy,
}: Props) {
    return (
        <div className="member-rating">
            {timestamp && (
                <div className="member-rating__title">{`${
                    ratingBy ?? "Member rating"
                } ·  ${format(fromTimestampToDate(timestamp), "dd MMM yyyy")}`}</div>
            )}
            <Stars maxRating={maxRating} userRating={userRating} />
            <div className="member-rating__message">{message ?? ""}</div>
        </div>
    );
}
